<template>
  <div :class="classes">
    <wt-paged-table :on-request-data="getTableData" :total-size="totalNumber" :page-size="pageSize" ref="table" v-loading="loading"  layout="total,sizes, prev, pager, next,jumper" :pageSizes="[10, 20, 50, 200]">
      <wt-table :list="tableData" :labels="tableLabels">
        <template>
          <template slot="before">
            <el-table-column label="商品" min-width="200" header-align="center" :fit="false">
                <template slot-scope="scope">
                    <div :class="$style['goods-price-name']">
                        <pt-img :class="$style['banner-picture']"
                        :src="scope.row.goods&&scope.row.goods[0]&&scope.row.goods[0].mainPicture" styleName="mall-goods-banner-pictures"></pt-img>
                         <div :class="$style['goods-name-price']">
                            <div> {{scope.row.goods[0].name}}</div>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="商品类型">
            <template slot-scope="scope">
                {{scope.row.goods&&scope.row.goods[0]&&scope.row.goods[0].typeName}}
            </template>
            </el-table-column>
            <el-table-column label="经营类型" >
            <template slot-scope="scope">
              {{scope.row.goodsBelong}}
            </template>
            </el-table-column>
            <el-table-column label="商品分组">
            <template slot-scope="scope">
                {{scope.row.goods&&scope.row.goods[0]&&scope.row.goods[0].groupName}}
            </template>
            </el-table-column>
            <el-table-column label="地区">
            <template slot-scope="scope">
              <span v-for="(item,index) in scope.row.goods[0].addresses" :key="index">
                {{item}}
              </span>
            </template>
            </el-table-column>
            <el-table-column label="订单号/下单时间" min-width="180">
            <template slot-scope="scope">
                <div>订单号：{{scope.row.orderNumber}}</div>
                <div>下单时间：{{scope.row.created_date}}</div>
            </template>
            </el-table-column>
             <el-table-column label="分值/数量" min-width="100">
                <template slot-scope="scope">
                    <div>
                      <div>{{scope.row.score}}</div>
                      <div>{{scope.row.goods_number}}件</div>
                    </div>
                </template>
            </el-table-column>
          </template>
          <slot />
        </template>
      </wt-table>
    </wt-paged-table>
  </div>
</template>

<script>
// 组件class前缀
const prefixCls = 'pt-integral-exchange-table'

export default {
  name: 'pt-integral-exchange-table',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    page () {
      return this.$refs.table.page
    }
  },
  props: {
    totalNumber: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 10
    },
    tableData: {
      type: Array,
      default: function () {
        return []
      }
    },
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      userBalance: true
    }
  },
  methods: {
    resetPage () {
      this.$refs.table.resetPage()
    },
    getTableData (page, next, size) {
      this.$emit('getIntegralExchangeList', page, next, size)
    },
    showReTry () {
      this.$refs.table.showReTry()
    },
    reload () {
      this.$refs.table.load()
    }
  }
}

</script>

<style module lang="less">
  /* 已启用css module， template中请使用$style.className添加class */
  /* 务必遵循css BEM原则 */
  .goods-price-name{
    display: flex
}
.goods-name-price{
    padding-left: 10px;
}
.banner-picture{
    max-width: 100px;
    max-height:100px;
    :global
    img{
        max-width: 100px;
        border-radius: 10px;
    }
}
</style>
